import { format } from 'date-fns';
export const formatCityDate = (city: string, date?: string, fallbackDate?: string) => {
    const resultDate = date || fallbackDate;

    if (!resultDate) {
        return city;
    }

    return `${city}, ${format(new Date(resultDate), 'dd.MM.yyyy')}`;
};
